const switchLabel = "_35ssfbt1ny";

export { switchLabel };
import "./atom.start-comma.style.linaria.module.css";
//# sourceMappingURL=atom.start-comma.style.js.map
